import { SavingsDto } from "src/types/SavingsDto"
import APIClient from "./apiClient"


export default new APIClient<SavingsDto>("/process-data")
